import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-orders-drawer',
  templateUrl: './orders-drawer.component.html'
})
export class OrdersDrawerComponent implements OnInit {
  selectedOrders: any;
  buttonLoadingForUpdate = false;

  constructor(private fb: UntypedFormBuilder, private drawerRef: NzDrawerRef<string>) {
  }
    ngOnInit() {
    }
  // To Stop Loading and close drawer
    editOrder($event) {
      this.buttonLoadingForUpdate = false;
      this.selectedOrders = $event;
      this.drawerRef.close($event);
    }
  // To Close drawer
    close(): void {
      this.drawerRef.close(this.selectedOrders);
    }

}
